<template>
    <div>
        <Head :title="`Chat #${this.chat.id}`"/>
        <div class="flex justify-start mb-8 max-w-full">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/girls">Girls</Link>
                <span class="text-indigo-400 font-medium">/</span>
                Chat #{{ this.chat.id }}
            </h1>
        </div>
        <div class="flex justify-content-between align-items-center">
            <div class="w-1/2 bg-white rounded-md shadow overflow-hidden mb-5 mr-2">
                <div class="w-full">
                    <h3 class="font-medium text-gray-900 text-center mt-5 px-6">
                        <Link :href="'/customers/'+this.customer.id+'/edit'">
                            Customer info
                        </Link>
                    </h3>
                    <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                <span
                    class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.customer.id }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    First name
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            this.customer.data.first_name
                        }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Last name
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            this.customer.data.last_name
                        }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    City
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.customer.data.city }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Gender search
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            this.customer.data.gender_search
                        }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Total sent messages by customer
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            customerMessages
                        }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Total sent messages with this girl
                    <span
                        class="text-gray-900 text-xs font-semibold float-right">{{
                            customerMessagesWithGirl
                        }}</span>
                </span>
                    </div>
                </div>
            </div>
            <div class="w-1/2 bg-white rounded-md shadow overflow-hidden mb-5 ml-2">
                <div class="w-full">
                    <h3 class="font-medium text-gray-900 text-center mt-5 px-6">
                        <Link :href="'/girls/'+this.girl.id">
                            Girl info
                        </Link>
                    </h3>
                    <div class="mt-5 mb-5 w-full flex flex-col items-center overflow-hidden text-sm">
                <span
                    class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Girl ID
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.id }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    First name
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.firstname }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Last name
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.lastname }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Nickname
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.nickname }}</span>
                </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Age
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.age }}</span>
                    </span>
                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150">
                    Distance
                    <span class="text-gray-900 text-xs font-semibold float-right">{{ this.girl.distance }}</span>
                </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-full bg-white rounded-md shadow overflow-hidden">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">

                <template v-for="message in messagesContent" :key="message.id">


                    <template v-if="message.payload.type === 'text'">

                        <span
                            class="w-full border-t border-gray-100 text-xs font-semibold font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150"
                            v-if="message.is_customer_message" v-html="highlightBlockerKeyword(message)">
                        </span>

                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-indigo-100 transition duration-150"
                            v-if="!message.is_customer_message">

                    <span class="text-gray-900 text-xs font-semibold float-right">{{ message.payload.content }}<br>
                            <span class="text-gray-400">{{ this.formatDate(message.created_at) }}</span></span>
                </span>

                    </template>

                    <template v-if="message.payload.type === 'photo'">

                        <span
                            class="w-full border-t border-gray-100 text-xs font-semibold font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-gray-100 transition duration-150"
                            v-if="message.is_customer_message">
                    <img :src="message.payload.content"><br>
                            <span class="text-gray-400">{{ this.formatDate(message.created_at) }}</span>
                </span>

                        <span
                            class="w-full border-t border-gray-100 font-bold text-gray-900 py-4 pl-6 pr-3 w-full block hover:bg-indigo-100 transition duration-150"
                            v-if="!message.is_customer_message">

                    <span class="text-gray-900 text-xs font-semibold float-right"><img :src="message.payload.content"><br>
                            <span class="text-gray-400">{{ this.formatDate(message.created_at) }}</span></span>
                </span>

                    </template>

                </template>


            </div>
            <form @submit.prevent="update">
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <text-input v-model="form.payload" :error="form.errors.token" class="pb-8 pr-6 w-full"
                                label="Message"/>

                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Send
                    </loading-button>
                    <loading-button
                        :loading="unlockLoading"
                        class="btn-indigo bg-green-500 hover:bg-green-600 ml-auto"
                        type="button"
                        v-if="chat.examination_required === true"
                        @click="unlockConversation()">Unlock
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import moment from 'moment'
import axios from 'axios'

export default {
    components: {
        FileInput,
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TrashedMessage,
    },
    layout: Layout,
    props: {
        customer: Object,
        girl: Object,
        chat: Object,
        messages: Array,
        customerMessagesWithGirl: Number,
        customerMessages: Number
    },
    remember: 'form',
    data() {
        return {
            messagesContent: [],
            newMessage: null,
            form: this.$inertia.form({
                type: 'text',
                payload: ''
            }),
            unlockLoading: false
        }
    },
    watch: {
        newMessage(value) {
            this.messagesContent.concat([value]);
        }
    },
    mounted() {
        this.messagesContent = this.messages;
        this.initPusher()
    },
    methods: {
        update() {
            if (this.form.payload.length === 0) {
                return;
            }

            this.form.post(`/chats/${this.chat.id}`, {
                onSuccess: () => this.form.reset('payload'),
            })
        },

        formatDate(value) {
            const date = moment.unix(value).utc();
            return date.format("YYYY-MM-DD HH:mm:ss")
        },
        initPusher() {
            window.Echo.channel('chat_' + this.chat.id)
                .listen('.new-message', (e) => {
                    this.newMessage = e.message;
                })
        },
        unlockConversation() {
            this.unlockLoading = true;
            axios.get(`/blocked-chats/unlock/${this.chat.id}`).then(result => {
                this.unlockLoading = false;
                if(result.data.success === true) {
                    this.chat.examination_required = false;
                }
            }).catch(err => this.unlockLoading = false);
        },
        highlightBlockerKeyword(message) {
            let result = message.payload.content;

            if(this.chat.examination_required) {
                result = this.replaceHighlightedText(result);
            }

            result += '<br>';
            result += '<span class="text-gray-400">'+this.formatDate(message.created_at)+'</span>';

            return result;
        },
        replaceHighlightedText(text) {
            const regex = new RegExp('('+this.chat.blocker_keywords?.join('|')+')', 'gi');

            text = text.replace(/(<mark class="highlight">|<\/mark>)/gim, '');

            const newText = text.replace(regex, '<mark style="background-color: #EEF43B;">$&</mark>');
            
            return newText;
        }
    },
}
</script>
